import React, { useContext } from "react";
import { Chevron } from "../../../assets/icons";
import HeadingSection from "../HeadingSection";
import profile from "../../../assets/defaultTestimonialAvatar.svg";
import ModalContext from "../../../Contexts/openModal";
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";
import NewCustomButton from "../../NewCustomButton";

const TestimonialDaliCard = ({ data, location }) => {
  const { toggleModal } = useContext(ModalContext);
  const emptyHeading = !!(
    data?.primary?.caption_title?.text ||
    data?.primary?.show_cta ||
    data?.primary?.description?.text ||
    data?.primary?.title?.text
  );
  const HomePage =
    location?.pathname == "/testing-slice/" || location?.pathname == "/";
  return (
    <div
      className={` text-white max-w-6xl w-auto mx-auto rounded-lg sm:px-12 lg:px-0 px-4`}
    >
      {emptyHeading && (
        <div className="flex justify-center">
          <HeadingSection
            data={data?.primary}
            headingStyle={`${data?.primary?.theme === "Dark" ? "text-white" : " text-purple-1100"} text-center lg:text-left`}
            sectionStyle={"items-center sm:!pb-10"}
            labelStyle={`${data?.primary?.theme === "Dark" ? "text-purple-350" : data?.primary?.theme === "Neutral" ? "text-purple-1100" : "text-purple-1500"}`}
            toggleModal={toggleModal}
          />
        </div>
      )}
      <div className="flex flex-col sm:flex-row items-center lg:px-18 justify-center ">
        <div className="flex sm:flex-col items-end gap-2.5 max-w-fit w-full">
          {data?.items[0]?.author_image?.url ? (
            <img
              src={data?.items[0]?.author_image?.url || profile}
              alt="Profile"
              loading="lazy"
              width={76}
              height={76}
              className=" sm:w-[76px] w-[60px] rounded-full "
            />
          ) : (
            <StaticImage
              height={100}
              width={100}
              src={"../../../assets/defaultTestimonialAvatar.svg"}
              alt="Profile"
              loading="lazy"
              izes="60px"
              className=" sm:w-[76px] w-[60px] rounded-full "
            />
          )}
          <div className="text-left sm:text-right">
            <p
              className={`${HomePage ? "text-base sm:text-lg" : "text-sm sm:text-lg"}  font-semibold sm:w-[200px] lg:w-full ${data?.primary?.theme === "Dark" ? "text-white" : "text-gray-2700"} `}
            >
              {data?.items[0]?.author_name?.text}
            </p>
            <p
              className={`${HomePage ? "text-sm sm:text-base" : "text-xs sm:text-base"}  font-normal ${data?.primary?.theme === "Dark" ? "text-gray-2200" : "text-gray-600"} max-w-[240px]`}
              dangerouslySetInnerHTML={{
                __html: data?.items[0]?.author_job_designation?.html,
              }}
            />
            {/* {data?.items[0]?.author_job_designation?.text}
            </p> */}
          </div>
        </div>
        <div
          className={`flex flex-col gap-5 lg:gap-6 border-t-[0.8px] sm:border-t-0 sm:border-l-[0.8px] border-gray-3005 mt-3 sm:mt-0 sm:ml-5 lg:ml-10 pt-3 sm:pt-0 sm:pl-5 lg:pl-10`}
        >
          <p
            className={`${HomePage ? "text-xl lg:text-3.25xl font-manrope text-left font-semibold  lg:tracking-[-1.5px] lg:leading-10" : "font-medium sm:text-xl text-lg md:tracking-[-0.4px] sm:tracking-[-0.5px] tracking-[-0.4px] lg:max-w-[631px]"}  px-3 sm:px-0 ${data?.primary?.theme === "Dark" ? " text-[#FFFFFF]" : "text-gray-2700"}  `}
          >
            {data?.items[0]?.testimonial_text?.text}
          </p>
          {data?.items[0]?.show_cta && (
            <NewCustomButton
              link={data?.items[0]?.cta_link?.url}
              text={data?.items[0]?.cta_text?.text}
              buttonClass={`bg-gray-1600 text-gray-2500 mx-0 w-full lg:w-auto ${data?.primary?.theme === "Neutral" ? "bg-white hover:bg-gray-2800" : "bg-gray-1600"}`}
              icon={<Chevron />}
              direction="right"
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TestimonialDaliCard;
